
import { API_HOST } from './constants';

import User from './User';
import Project from './Project';
import Story from './Story';
import Page from './Page';
import Profile from './Profile';
import Categories from './Categories';
import Audio from './Audio';
import Cover from './Cover';
import PublishedGames from './PublishedGames';

export class Api {
  static checkTokenAvailable() {
    return null;
    //if (!window.localStorage) return;
    
    //return window.localStorage.getItem('session_token');
  }

  static getOauthToken() {
    return window.location.search.split('code=')[1];
  }

  static removeToken() {
    window.localStorage.removeItem('session_token');
    window.localStorage.removeItem('user_id');
    window.localStorage.removeItem('user_name');
  }
}

Api.User = User;
Api.Project = Project;
Api.Story = Story;
Api.Page = Page;
Api.Profile = Profile;
Api.Audio = Audio;
Api.Cover = Cover;
Api.Categories = Categories;
Api.API_HOST = API_HOST;
Api.PublishedGames = PublishedGames;

export default Api;



// WEBPACK FOOTER //
// ./src/api/Api.js